import React, { useState } from "react";
import { Field, Form, Formik } from "formik";
import {
  Button,
  Card,
  InputGroup,
  Form as BootstrapForm,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import * as Yup from "yup";
import styles from "./AddProductForm.module.css";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { createProduct, updateProduct } from "../../actions/Book.action";

const AddProductForm = ({ createProduct, update, data, updateProduct }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [primaryImage, setprimaryImage] = useState(undefined);
  const [images, setimages] = useState(undefined);

  const navigate = useNavigate();

  const onSubmitHandeler = async (values) => {
    setIsLoading(true);
    let check =
      update === true
        ? await updateProduct(values, primaryImage, images, data._id)
        : await createProduct(values, primaryImage, images);
    if (check === true) {
      setTimeout(() => {
        setIsLoading(false);
        navigate(-1);
      }, 1000);
    } else {
      setIsLoading(false);
    }
  };

  //ONSELECT FILE HANDELER
  const onSelectFile2 = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setprimaryImage(undefined);
      return;
    }
    if (e.target.files[0].size > 2000000) {
      toast.error("File size must be less than 2MB");
      return;
    }
    setprimaryImage(e.target.files[0]);
  };

  //ONSELECT FILES HANDELER
  const onSelectFiles = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setimages(undefined);
      return;
    }
    if (e.target.files[0].size > 2000000) {
      toast.error("File size must be less than 2MB");
      return;
    }
    setimages(e.target.files);
  };

  let initVals = {
    name: data && data.name ? data.name : "",
    productId: data && data.id ? data.id : "",
    productPrice: data && data.price ? parseInt(data.price) : 0,
    stock: data && data.stock ? data.stock : "",
    description: data && data.description ? data.description : "",
  };

  const SignupSchema = Yup.object().shape({
    name: Yup.string().required("Name is required!"),
    productId: Yup.string().required("Product ID is required!"),
    productPrice: Yup.string().required("Price is required!"),
    stock: Yup.string().required("Stock is required!"),
    description: Yup.string().required("Description is required!"),
  });
  return (
    <Container className="pb-4">
      <Card bg="white" text="dark" className={`crd shadow`}>
        <Card.Body>
          <h1 className="fs-4 fw-normal py-3">
            Fill the form to {update ? "update" : "add"} product
          </h1>

          <Formik
            initialValues={initVals}
            validationSchema={SignupSchema}
            enableReinitialize={true}
            onSubmit={(values) => onSubmitHandeler(values)}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form>
                <InputGroup className="mb-3 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-center pb-2">
                    <label htmlFor="name" className="d-block">
                      Name
                    </label>
                    {errors.name && touched.name ? (
                      <small className="text-danger ">{errors.name}</small>
                    ) : null}
                  </div>
                  <Field
                    as={BootstrapForm.Control}
                    placeholder="Type name of product..."
                    name="name"
                    isValid={!errors.name && touched.name}
                    type="text"
                    autoComplete="off"
                    className={`${styles.input} w-100`}
                    isInvalid={errors.name && touched.name}
                  />
                </InputGroup>

                <Row>
                  <Col>
                    <InputGroup className="mb-3 d-flex flex-column">
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <label htmlFor="productId" className="d-block">
                          Product ID
                        </label>
                        {errors.productId && touched.productId ? (
                          <small className="text-danger">
                            {errors.productId}
                          </small>
                        ) : null}
                      </div>
                      <Field
                        as={BootstrapForm.Control}
                        placeholder="Product ID..."
                        name="productId"
                        isValid={!errors.productId && touched.productId}
                        type="text"
                        className={`${styles.input} w-100`}
                        isInvalid={errors.productId && touched.productId}
                      />
                    </InputGroup>
                  </Col>
                </Row>

                <InputGroup className="mb-3 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-center pb-2">
                    <label htmlFor="productPrice" className="d-block">
                      Product Price
                    </label>
                    {errors.productPrice && touched.productPrice ? (
                      <small className="text-danger">
                        {errors.productPrice}
                      </small>
                    ) : null}
                  </div>
                  <Field
                    as={BootstrapForm.Control}
                    placeholder="Product Price..."
                    name="productPrice"
                    isValid={!errors.productPrice && touched.productPrice}
                    type="text"
                    className={`${styles.input} w-100`}
                    isInvalid={errors.productPrice && touched.productPrice}
                  />
                </InputGroup>
                <InputGroup className="mb-3 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-center pb-2">
                    <label htmlFor="stock" className="d-block">
                      Stock
                    </label>
                    {errors.stock && touched.stock ? (
                      <small className="text-danger">{errors.stock}</small>
                    ) : null}
                  </div>
                  <Field
                    as={BootstrapForm.Control}
                    placeholder="Product Stock..."
                    name="stock"
                    isValid={!errors.stock && touched.stock}
                    type="text"
                    className={`${styles.input} w-100`}
                    isInvalid={errors.stock && touched.stock}
                  />
                </InputGroup>

                <InputGroup className="mb-3 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-center pb-2">
                    <label htmlFor="description" className="d-block">
                      Description
                    </label>
                    {errors.description && touched.description ? (
                      <small className="text-danger">
                        {errors.description}
                      </small>
                    ) : null}
                  </div>
                  <Field
                    as={"textarea"}
                    placeholder="Description..."
                    name="description"
                    isValid={!errors.description && touched.description}
                    type="text"
                    className={`${styles.input} form-control w-100`}
                    rows={10}
                    isInvalid={errors.description && touched.description}
                  />
                </InputGroup>
                <InputGroup className="mb-3 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-center pb-2">
                    <label htmlFor="image" className="d-block">
                      Primary Image{" "}
                      {data && data.primaryImage ? `(Uploaded)` : ""}
                    </label>
                  </div>
                  <BootstrapForm.Control
                    type="file"
                    id="image"
                    className={`${styles.logo} w-100`}
                    onChange={(e) => onSelectFile2(e)}
                  />
                </InputGroup>
                <InputGroup className="mb-3 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-center pb-2">
                    <label htmlFor="image" className="d-block">
                      Slider Images{" "}
                      {data && data.images && data.images.length > 0
                        ? `(Uploaded)`
                        : ""}
                    </label>
                  </div>
                  <BootstrapForm.Control
                    type="file"
                    id="image"
                    multiple
                    className={`${styles.logo} w-100`}
                    onChange={(e) => onSelectFiles(e)}
                  />
                </InputGroup>

                <div className="pt-4">
                  <Button
                    variant="primary"
                    type="submit"
                    className="btn_primary"
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : update ? "Save" : "Add Product"}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default connect(null, {
  createProduct,
  updateProduct,
})(AddProductForm);
